export class AppSettings {
    public static URL_Masters = '';
    public static URL_Users = '';
    public static URL_PMSService = '';
    public static URL_ComplainService = '';
    public static URL_Session = '';
    public static URL_Messaging = '';
    public static URL_Central = '';
    public static URL_AdvancedReports = '';
    public static URL_OldHTML = '';
    public static URL_Config = '';
    public static URL_KMTConfig = '';
    public static Domain = '';
    public static URL_GlitchService = '';
    public static URL_HK = '';
    public static URL_Inspection = '';
    public static URL_KMT = "";
    public static URL_DEV_KMT = "";
    public static URL_PlatformConfigHTML = "";
    public static URL_KMTMasters = "";
    public static URL_WorkOrders = "";
    public static URL_Checklist = "";
    public static URL_Attachments = "";
    public static ShowICPNumber = '';
    public static ShowHTMLConfig = '';
    public static ShowSilverlightConfig = '';
    public static ShowGlitchVisitorSearch = false;
    public static GuestImageURL = "/Pages/Guest_Image";
    public static StaffImageURL = "/Pages/Staff_Image";
    public static MAX_UPLOAD_SIZE = 1024 * 1024 * 10; // --- In Bytes
    public static MAX_IMAGE_SIZE = 1024 * 1024 * 5;
    public static IDTokenExpiry = null;
    public static WebSecurity = false;
    public static URL_Analytics_Glitch;
    public static URL_Analytics_Service;
    public static URL_Analytics_HK;
    public static URL_Inventory;
    public static MAX_CALLS:number = 20; // --- In Bytes
    public static MAX_GLITCHES: number = 20;
    public static MaxUploadSize_MB(): number {
        return Math.floor((AppSettings.MAX_UPLOAD_SIZE / 1024) / 1024);
    }

    public static MaxImageSize_MB(): number {
        return Math.floor((AppSettings.MAX_IMAGE_SIZE / 1024) / 1024);
    }

    public static EnableUnifocusSSO = false;
    public static IsRunningInSingularity = false;
    public static ShowAdvanceReportDirectly = false;
    public static APP_DEBUG = false;
}
